var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"elevate-5 pa-5 ma-5 text-center"},[_c('h1',{staticClass:"display-3"},[_vm._v(_vm._s(_vm.$t("404")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }